<template>
  <div>
    <div class="pt-24 pb-8 lg:px-20 md:px-20 px-5 absolute top-0 left-0 z-10">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item class="fsize16 cursor-pointer"
          ><button class="custom-btn" @click="handleClickHome">
            Home
          </button></el-breadcrumb-item
        >
        <el-breadcrumb-item class="fsize16">E-Learning</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="relative">
      <!-- <div class="absolute bg-design1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/bgd1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design2 mob-hidden">
          <img src="../../../assets/images/bg-des/bgd2.svg" alt="bg-polygon" />
        </div>
        <div class="absolute bg-design3 mob-hidden">
          <img
            src="../../../assets/images/Ellipse 12.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div> -->
      <div class="h-95per">
        <img
          src="../../../../assets/images/cp-bg.png"
          alt="cp bg"
          class="absolute h-640px right-0 bg-white"
        />
      </div>
      <div
        class="lg:px-20 md:px-20 px-5 lg:flex md:flex items-center lg:gap-10 md:gap-10 absolute top-32 custflexdirection"
      >
        <!-- <img
            src="../../../assets/images/cp-bg.png"
            alt="cp bg"
            class="min-hidden w-80per absolute top-0 right-0 line-bgh-525px z-index--1"
          /> -->
        <div
          class="lg:w-1/2 md:w-1/2 w-full lg:mt-0 md:mt-0 mt-3 md:hidden lg:hidden block"
        >
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/homepage/Banner1.webp"
            class="custborderradius"
            alt="swiper-img"
          />
        </div>
        <div class="lg:w-1/2 md:w-1/2 w-full lg:m-5 md:m-5">
          <div class="">
            <p
              class="font-semibold fsize35 md-fsize25 sm-fsize24 line-h60 letter-s016px text-black leading-snug lg:w-full md:w-full"
            >
              <!-- ONE-STOP platform for ALL your caregiving needs! -->
              Begin your learning journey with us
            </p>

            <p
              class="fsize25 md-fsize18 sm-fsize14 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20"
            >
              <!-- Get access to exclusive tools, benefits and curated services.
                Ease your caregiving journey to make time for happy memories and
                a fuller life. -->
              We help you to build your capacity as a caregiver, for a
              gratifying caregiving experience.

              <!-- <a
                  v-if="!isLogedIn"
                  @click.stop="handleClick('register')"
                  class="underline text-4f0a4b min-hidden font-semibold cursor-pointer"
                  >Register</a
                > -->
            </p>
            <div class="lg:pt-8 md:pt-8 pt-0">
              <!-- <base-button type="primary" class="cust-btn-wh btntext"
              >Know more</base-button
            > -->
              <div class="pt-2 md:w-3/4 w-full lg:w-3/4 relative">
                <!-- <b-form-input
                  placeholder="Explore Courses"
                  class="rounded-full el-home-inpt-cvr"
                  v-model="search"
                ></b-form-input> -->

                <b-button
                  variant="outline-primary"
                  class="rounded-full bg-primary text-white border-2 font-semibold"
                  @click="handleClick('e-courses')"
                  >Explore Courses</b-button
                >
              </div>
              <p
                class="lg:text-xl md:text-xl text-sm sm-fsize6 font-italic lg:pt-6 md:pt-6 pt-2 lh40px sm-lh20"
              >
                "The greatest achievements are those that benefits others"
              </p>

              <p
                class="lh40px sm-lh20 font-italic"
                style="text-align: -webkit-right"
              >
                -Denis E Waitely
              </p>
            </div>
            <!-- <div>
              <span
                @click="handleClick('serviceform')"
                class="underline text-4f0a4b min-hidden md-fsize14 font-semibold cursor-pointer"
                >Care assistant</span
              >
              <div class="flex lg:pt-4 md:pt-4 mob-hidden">
                <base-button
                  type="primary"
                  class="btntext"
                  @click="handleClick('serviceform')"
                  >Care assistant</base-button
                >
              </div>
            </div> -->
          </div>
        </div>
        <div class="lg:w-1/2 md:w-1/2 w-full mob-hidden">
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Cg-img/elearningpage%20-%20image%201.jpg"
            class="custborderradius m-auto"
            alt=""
          />
          <!-- <img
              src="../../../assets/images/swiper-img/ww-mob-1.svg"
              class="w-full absolute md:hidden lg:hidden block"
              alt="swiper-img"
            /> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      search: "",
    };
  },
  methods: {
    async handleClick(name) {
      await this.$store.commit("eLearning/SET_SEARCH", this.search);
      this.$router.push({ name: name });
      // this.toggleNavbar();
    },
    async handleClickHome() {
      this.$router.push({ name: "home" });
    },
  },
};
</script>

<style scoped>
.custom-btn {
  all: unset;
  cursor: pointer;
}

.custom-btn:focus {
  outline: none;
}
</style>
